import { useContext } from 'react';

import { FeaturesContext } from './constants';
import { TFeature } from './interfaces';

export const useIsFeatureAvailable = (alias?: TFeature): boolean => {
  const { features } = useContext(FeaturesContext);

  if (!alias) return true;

  return features?.includes(alias);
};
